export default {
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    add: 'Agregar',
    remove: 'Quitar',
    search: 'Buscar',
    filter: 'Filtrar',
    loading: 'Cargando...',
    noResults: 'No se encontraron resultados',
    confirm: 'Confirmar',
    back: 'Volver',
    next: 'Siguiente',
    previous: 'Anterior',
    actions: 'Acciones',
    status: 'Estado',
    priority: 'Prioridad',
    date: 'Fecha',
    name: 'Nombre',
    email: 'Correo electronico',
    phone: 'Telefono',
    description: 'Descripcion',
    notes: 'Notas',
    attachments: 'Adjuntos',
    createdAt: 'Creado el',
    updatedAt: 'Actualizado el',
    createdBy: 'Creado por',
    yes: 'Si',
    no: 'No',
    all: 'Todos',
    none: 'Ninguno',
    required: 'Requerido',
    optional: 'Opcional',
    success: 'Exito',
    error: 'Error',
    warning: 'Advertencia',
    info: 'Informacion',
    close: 'Cerrar',
    open: 'Abrir',
    view: 'Ver',
    details: 'Detalles',
    submit: 'Enviar',
    send: 'Enviar',
    reset: 'Restablecer',
    clear: 'Limpiar',
    copy: 'Copiar',
    download: 'Descargar',
    upload: 'Subir',
    export: 'Exportar',
    import: 'Importar',
    refresh: 'Actualizar',
    more: 'Mas',
    less: 'Menos',
    showAll: 'Ver todos',
    hideAll: 'Ocultar todos',
    selectAll: 'Seleccionar todos',
    deselectAll: 'Deseleccionar todos',
    noData: 'Sin datos',
    emptyState: 'No hay elementos para mostrar',
    active: 'Activo',
    inactive: 'Inactivo',
    you: 'Tu',
    time: 'Hora',
  },

  auth: {
    login: 'Iniciar sesion',
    logout: 'Cerrar sesion',
    register: 'Registrarse',
    email: 'Correo electronico',
    password: 'Contrasena',
    confirmPassword: 'Confirmar contrasena',
    forgotPassword: 'Olvide mi contrasena',
    resetPasswordTitle: 'Restablecer contrasena',
    resetPassword: {
      title: 'Restablecer contrasena',
      subtitle: 'Ingresa tu nueva contrasena',
      newPassword: 'Nueva contrasena',
      submit: 'Restablecer contrasena',
      invalidCode: 'El enlace de restablecimiento no es valido.',
      expiredCode: 'El enlace de restablecimiento ha expirado. Solicita uno nuevo.',
      successMessage: 'Tu contrasena ha sido restablecida correctamente. Ya puedes iniciar sesion.',
      genericError: 'Error al restablecer la contrasena. Intenta de nuevo.',
      requestNewLink: 'Solicitar nuevo enlace',
    },
    rememberMe: 'Recordarme',
    signInWithGoogle: 'Iniciar sesion con Google',
    noAccount: 'No tienes cuenta?',
    hasAccount: 'Ya tienes cuenta?',
    createAccount: 'Crear cuenta',
    welcomeBack: 'Bienvenido de nuevo',
    welcomeNew: 'Bienvenido a Torcaza Projects',
    loginSubtitle: 'Ingresa tus credenciales para acceder',
    registerSubtitle: 'Crea tu cuenta para comenzar',
    invalidCredentials: 'Credenciales invalidas',
    emailRequired: 'El correo electronico es requerido',
    passwordRequired: 'La contrasena es requerida',
    passwordMinLength: 'La contrasena debe tener al menos 8 caracteres',
    passwordMismatch: 'Las contrasenas no coinciden',
    emailInvalid: 'El correo electronico no es valido',
    resetEmailSent: 'Se ha enviado un correo para restablecer tu contrasena',
    companyName: 'Nombre de la empresa',
    fullName: 'Nombre completo',
  },

  navigation: {
    dashboard: 'Dashboard',
    home: 'Inicio',
    crm: 'CRM',
    commercial: 'Comercial',
    pipeline: 'Pipeline',
    prospects: 'Prospectos',
    clients: 'Clientes',
    organizations: 'Organizaciones',
    myOrganization: 'Mi Organizacion',
    projects: 'Proyectos',
    requirements: 'Requerimientos',
    releases: 'Releases',
    petitions: 'Peticiones',
    tickets: 'Tickets',
    quotations: 'Cotizaciones',
    salesOrders: 'Ordenes de Venta',
    appointments: 'Agendamientos',
    users: 'Usuarios',
    settings: 'Configuracion',
    activityLog: 'Historial de Actividad',
    profile: 'Perfil',
    notifications: 'Notificaciones',
    backlog: 'Backlog',
    sprintBoard: 'Tablero de Sprint',
    management: 'Gestion',
    applications: 'Aplicaciones',
    implementations: 'Implementaciones',
  },

  dashboard: {
    welcome: 'Bienvenido, {name}',
    overview: 'Resumen',
    recentActivity: 'Actividad reciente',
    activeProjects: 'Proyectos activos',
    openTickets: 'Tickets abiertos',
    pendingRequirements: 'Requerimientos pendientes',
    upcomingAppointments: 'Proximas citas',
    salesPipeline: 'Pipeline de ventas',
    projectsOverview: 'Resumen de proyectos',
    ticketsOverview: 'Resumen de tickets',
    totalUsers: 'Total usuarios',
    totalSales: 'Ventas totales',
    totalProducts: 'Total productos',
    quickActions: 'Acciones rapidas',
    newTicket: 'Nuevo ticket',
    newRequirement: 'Nuevo requerimiento',
    scheduleAppointment: 'Agendar cita',
    requestQuotation: 'Solicitar cotizacion',
  },

  users: {
    title: 'Usuarios',
    subtitle: 'Gestiona los usuarios del sistema',
    createUser: 'Crear usuario',
    newUser: 'Nuevo usuario',
    editUser: 'Editar usuario',
    deleteUser: 'Eliminar usuario',
    createUserDescription: 'Completa los datos para crear un nuevo usuario',
    editUserDescription: 'Modifica los datos del usuario',
    deleteConfirm: 'Estas seguro que deseas eliminar este usuario?',
    deleteConfirmTitle: 'Eliminar usuario',
    deleteConfirmMessage: 'Estas seguro que deseas eliminar a {name}? Esta accion no se puede deshacer.',
    role: 'Rol',
    selectRole: 'Seleccionar rol',
    organization: 'Organizacion',
    selectOrganization: 'Seleccionar organizacion',
    active: 'Activo',
    inactive: 'Inactivo',
    activate: 'Activar',
    deactivate: 'Desactivar',
    activeStatus: 'Estado activo',
    activeStatusDescription: 'Los usuarios inactivos no pueden iniciar sesion',
    lastLogin: 'Ultimo acceso',
    noUsers: 'No hay usuarios registrados',
    searchPlaceholder: 'Buscar por nombre o email...',
    filterByRole: 'Filtrar por rol',
    emailPlaceholder: "correo{'@'}ejemplo.com",
    passwordPlaceholder: 'Minimo 6 caracteres',
    namePlaceholder: 'Nombre completo',
    phonePlaceholder: '+1 234 567 8900',
    stats: {
      total: 'Total usuarios',
      active: 'Usuarios activos',
      admins: 'Administradores',
      clients: 'Clientes',
    },
    table: {
      user: 'Usuario',
      role: 'Rol',
      status: 'Estado',
      createdAt: 'Fecha de creacion',
    },
  },

  organizations: {
    title: 'Organizaciones',
    subtitle: 'Gestiona las organizaciones de clientes',
    newOrganization: 'Nueva organizacion',
    editOrganization: 'Editar organizacion',
    deleteOrganization: 'Eliminar organizacion',
    deleteConfirm: 'Estas seguro que deseas eliminar esta organizacion?',
    deleteConfirmTitle: 'Eliminar organizacion',
    deleteConfirmMessage: 'Estas seguro que deseas eliminar {name}? Esta accion no se puede deshacer.',
    createDescription: 'Completa los datos para crear una nueva organizacion',
    editDescription: 'Modifica los datos de la organizacion',
    info: 'Informacion',
    industry: 'Industria',
    website: 'Sitio web',
    address: 'Direccion',
    owner: 'Propietario',
    members: 'Miembros',
    membersDescription: 'Usuarios que pertenecen a esta organizacion',
    noOrganizations: 'No hay organizaciones registradas',
    noMembers: 'No hay miembros en esta organizacion',
    noOwner: 'Sin propietario asignado',
    notFound: 'Organizacion no encontrada',
    createdOn: 'Creada el',
    inviteMember: 'Invitar miembro',
    removeMember: 'Remover miembro',
    activeDescription: 'Las organizaciones inactivas no pueden acceder al sistema',
    searchPlaceholder: 'Buscar por nombre o email...',
    namePlaceholder: 'Nombre de la organizacion',
    emailPlaceholder: "contacto{'@'}empresa.com",
    phonePlaceholder: '+1 234 567 8900',
    addressPlaceholder: 'Direccion de la empresa',
    websitePlaceholder: 'https://www.empresa.com',
    notesPlaceholder: 'Notas adicionales...',
    stats: {
      total: 'Total organizaciones',
      active: 'Activas',
      members: 'Total miembros',
    },
    table: {
      name: 'Organizacion',
      contact: 'Contacto',
      members: 'Miembros',
      status: 'Estado',
      createdAt: 'Fecha de creacion',
    },
  },

  myOrganization: {
    subtitle: 'Informacion de tu organizacion',
    noOrganization: 'No perteneces a ninguna organizacion',
    noOrganizationDescription: 'Contacta a tu administrador para ser agregado a una organizacion.',
    membersDescription: 'Miembros de tu equipo',
  },

  crm: {
    title: 'CRM',
    pipeline: 'Pipeline',
    pipelineSubtitle: 'Gestiona tus prospectos y oportunidades de venta',
    prospects: 'Prospectos',
    prospectsSubtitle: 'Lista de prospectos y leads de ventas',
    newProspect: 'Nuevo prospecto',
    editProspect: 'Editar prospecto',
    deleteProspect: 'Eliminar prospecto',
    deleteProspectConfirm: 'Estas seguro que deseas eliminar el prospecto',
    companyName: 'Nombre de empresa',
    contactName: 'Nombre de contacto',
    source: 'Fuente',
    stage: 'Etapa',
    industry: 'Industria',
    estimatedValue: 'Valor estimado',
    assignedTo: 'Asignado a',
    notes: 'Notas',
    convertToOrganization: 'Convertir a organizacion',
    convertConfirm: 'Estas seguro que deseas convertir este prospecto en organizacion?',
    convertDescription: 'Se creara una nueva organizacion con los datos del prospecto y el prospecto pasara a estado "Ganado".',
    noProspects: 'No hay prospectos registrados',
    notFound: 'Prospecto no encontrado',
    activities: 'Actividades',
    logActivity: 'Registrar actividad',
    activityType: 'Tipo de actividad',
    activityTitle: 'Titulo de la actividad',
    duration: 'Duracion',
    noActivities: 'No hay actividades registradas',
    time: 'Hora',
    stages: {
      prospect: 'Prospecto',
      contacted: 'Contactado',
      proposal_sent: 'Propuesta enviada',
      negotiation: 'Negociacion',
      won: 'Ganado',
      lost: 'Perdido',
    },
    activityTypes: {
      call: 'Llamada',
      email: 'Email',
      meeting: 'Reunion',
      note: 'Nota',
    },
  },

  projects: {
    title: 'Proyectos',
    subtitle: 'Gestiona tus proyectos de desarrollo',
    newProject: 'Nuevo proyecto',
    editProject: 'Editar proyecto',
    deleteProject: 'Eliminar proyecto',
    deleteConfirm: 'Estas seguro que deseas eliminar este proyecto?',
    status: 'Estado',
    organization: 'Organizacion',
    team: 'Equipo',
    operators: 'Operadores asignados',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    budget: 'Presupuesto estimado',
    technologies: 'Tecnologias',
    repository: 'Repositorio',
    productionUrl: 'URL de produccion',
    stagingUrl: 'URL de staging',
    documents: 'Documentos',
    noProjects: 'No hay proyectos registrados',
    statuses: {
      definition: 'Definicion',
      in_development: 'En desarrollo',
      qa: 'QA',
      uat: 'UAT',
      production: 'Produccion',
      maintenance: 'Mantenimiento',
      completed: 'Completado',
      on_hold: 'En pausa',
    },
  },

  requirements: {
    title: 'Requerimientos',
    subtitle: 'Gestiona los requerimientos de los proyectos',
    newRequirement: 'Nuevo requerimiento',
    editRequirement: 'Editar requerimiento',
    deleteRequirement: 'Eliminar requerimiento',
    deleteConfirm: 'Estas seguro que deseas eliminar este requerimiento?',
    type: 'Tipo',
    priority: 'Prioridad',
    definitionStatus: 'Estado de definicion',
    developmentStatus: 'Estado de desarrollo',
    estimatedHours: 'Horas estimadas',
    effortPoints: 'Puntos de esfuerzo',
    actualHours: 'Horas reales',
    assignedTo: 'Asignado a',
    release: 'Release',
    approve: 'Aprobar',
    reject: 'Rechazar',
    clientNotes: 'Notas del cliente',
    internalNotes: 'Notas internas',
    noRequirements: 'No hay requerimientos registrados',
    board: 'Tablero',
    list: 'Lista',
  },

  releases: {
    title: 'Releases',
    subtitle: 'Gestiona los releases de los proyectos',
    newRelease: 'Nuevo release',
    editRelease: 'Editar release',
    deleteRelease: 'Eliminar release',
    deleteConfirm: 'Estas seguro que deseas eliminar este release?',
    name: 'Nombre',
    version: 'Version',
    status: 'Estado',
    plannedDate: 'Fecha planificada',
    deployedAt: 'Desplegado el',
    releaseNotes: 'Notas de release',
    requirements: 'Requerimientos incluidos',
    noReleases: 'No hay releases registrados',
  },

  tickets: {
    title: 'Tickets',
    subtitle: 'Gestiona tickets de soporte y consultas',
    newTicket: 'Nuevo ticket',
    editTicket: 'Editar ticket',
    deleteTicket: 'Eliminar ticket',
    deleteConfirm: 'Estas seguro que deseas eliminar este ticket?',
    ticketTitle: 'Titulo',
    organization: 'Organizacion',
    project: 'Proyecto',
    type: 'Tipo',
    priority: 'Prioridad',
    status: 'Estado',
    assignedTo: 'Asignado a',
    sla: 'SLA',
    responseTime: 'Tiempo de respuesta',
    resolutionTime: 'Tiempo de resolucion',
    respondedAt: 'Respondido el',
    resolvedAt: 'Resuelto el',
    convertToRequirement: 'Convertir a requerimiento',
    noTickets: 'No hay tickets registrados',
    slaStatus: {
      onTime: 'En tiempo',
      atRisk: 'En riesgo',
      overdue: 'Vencido',
    },
  },

  quotations: {
    title: 'Cotizaciones',
    subtitle: 'Gestiona cotizaciones y solicitudes',
    newQuotation: 'Nueva cotizacion',
    editQuotation: 'Editar cotizacion',
    deleteQuotation: 'Eliminar cotizacion',
    deleteConfirm: 'Estas seguro que deseas eliminar esta cotizacion?',
    requestQuotation: 'Solicitar cotizacion',
    projectName: 'Nombre del proyecto',
    projectType: 'Tipo de proyecto',
    hasDesigns: 'Tiene disenos?',
    designsUrl: 'URL de disenos',
    desiredDeadline: 'Fecha deseada',
    estimatedBudget: 'Presupuesto estimado',
    quotedAmount: 'Monto cotizado',
    validUntil: 'Valida hasta',
    features: 'Funcionalidades',
    convertToProject: 'Convertir a proyecto',
    noQuotations: 'No hay cotizaciones registradas',
    submitQuote: 'Enviar cotizacion',
    approve: 'Aprobar',
    reject: 'Rechazar',
    pending: 'Pendiente',
    quoted: 'Cotizada',
    approved: 'Aprobada',
    rejected: 'Rechazada',
    expired: 'Expirada',
    internalNotes: 'Notas internas',
    rejectionReason: 'Motivo de rechazo',
  },

  salesOrders: {
    title: 'Ordenes de Venta',
    subtitle: 'Gestiona ordenes de venta',
    newOrder: 'Nueva orden',
    editOrder: 'Editar orden',
    deleteOrder: 'Eliminar orden',
    deleteConfirm: 'Estas seguro que deseas eliminar esta orden?',
    orderNumber: 'Numero de orden',
    status: 'Estado',
    items: 'Items',
    subtotal: 'Subtotal',
    tax: 'Impuesto',
    taxRate: 'Tasa de impuesto',
    discount: 'Descuento',
    total: 'Total',
    validUntil: 'Valida hasta',
    acceptedAt: 'Aceptada el',
    noOrders: 'No hay ordenes registradas',
    addItem: 'Agregar item',
    removeItem: 'Quitar item',
    itemDescription: 'Descripcion',
    quantity: 'Cantidad',
    unitPrice: 'Precio unitario',
  },

  appointments: {
    title: 'Agendamientos',
    subtitle: 'Gestiona citas y reuniones',
    newAppointment: 'Nueva cita',
    editAppointment: 'Editar cita',
    viewAppointment: 'Ver cita',
    deleteAppointment: 'Eliminar cita',
    deleteConfirm: 'Estas seguro que deseas eliminar esta cita?',
    requestAppointment: 'Solicitar cita',
    titleLabel: 'Titulo',
    type: 'Tipo',
    status: 'Estado',
    requestedDateTime: 'Fecha/hora solicitada',
    proposedDateTimes: 'Fechas/horas propuestas',
    confirmedDateTime: 'Fecha/hora confirmada',
    meetingUrl: 'URL de reunion',
    assignedTo: 'Asignado a',
    proposeTimes: 'Proponer horarios',
    confirmAppointment: 'Confirmar cita',
    noAppointments: 'No hay citas registradas',
    types: {
      initial_contact: 'Contacto inicial',
      project_review: 'Revision de proyecto',
      demo: 'Demo',
      support: 'Soporte',
      other: 'Otro',
    },
  },

  comments: {
    title: 'Comentarios',
    newComment: 'Nuevo comentario',
    editComment: 'Editar comentario',
    deleteComment: 'Eliminar comentario',
    deleteConfirm: 'Estas seguro que deseas eliminar este comentario?',
    internal: 'Comentario interno',
    internalComment: 'Comentario interno (solo visible para el equipo)',
    internalHint: 'Solo visible para el equipo',
    noComments: 'No hay comentarios',
    beFirst: 'Se el primero en comentar',
    addComment: 'Agregar comentario',
    placeholder: 'Escribe tu comentario...',
    shortcut: 'Presiona Ctrl+Enter para enviar',
  },

  activityLog: {
    title: 'Historial de Actividad',
    subtitle: 'Registro de cambios y acciones',
    action: 'Accion',
    entity: 'Entidad',
    user: 'Usuario',
    date: 'Fecha',
    changes: 'Cambios',
    noLogs: 'No hay registros de actividad',
    actions: {
      created: 'Creado',
      updated: 'Actualizado',
      deleted: 'Eliminado',
      status_changed: 'Estado cambiado',
      assigned: 'Asignado',
      commented: 'Comentado',
    },
  },

  settings: {
    title: 'Configuracion',
    subtitle: 'Configura las opciones del sistema',
    general: 'General',
    sla: 'SLA',
    slaSettings: {
      title: 'Configuracion de SLA',
      subtitle: 'Define los tiempos de respuesta y resolucion',
      priority: 'Prioridad',
      responseTime: 'Tiempo de respuesta (horas)',
      resolutionTime: 'Tiempo de resolucion (horas)',
    },
    theme: {
      title: 'Tema',
      light: 'Claro',
      dark: 'Oscuro',
      system: 'Sistema',
    },
    language: {
      title: 'Idioma',
      spanish: 'Espanol',
      english: 'Ingles',
    },
  },

  profile: {
    title: 'Perfil',
    subtitle: 'Gestiona tu informacion personal y preferencias',
    personalInfo: 'Informacion personal',
    personalInfoDesc: 'Actualiza tu nombre y datos de contacto',
    displayName: 'Nombre',
    phonePlaceholder: '+56 9 1234 5678',
    phoneInvalid: 'Solo se permiten numeros, espacios, guiones y +',
    phoneTooShort: 'El numero es muy corto (minimo 7 digitos)',
    phoneTooLong: 'El numero es muy largo (maximo 15 digitos)',
    saved: 'Guardado correctamente',
    preferences: 'Preferencias',
    preferencesDesc: 'Personaliza la apariencia y el idioma de la aplicacion',
    themeDesc: 'Selecciona el tema de la interfaz',
    languageDesc: 'Selecciona el idioma de la aplicacion',
    security: 'Seguridad',
    securityDesc: 'Cambia tu contrasena para mantener tu cuenta segura',
    currentPassword: 'Contrasena actual',
    newPassword: 'Nueva contrasena',
    confirmPassword: 'Confirmar nueva contrasena',
    changePassword: 'Cambiar contrasena',
    passwordMinLength: 'Minimo 8 caracteres',
    passwordMinLengthHint: 'Minimo 8 caracteres',
    passwordMismatch: 'Las contrasenas no coinciden',
    passwordChanged: 'Contrasena actualizada correctamente',
    wrongPassword: 'La contrasena actual es incorrecta',
    samePassword: 'La nueva contrasena debe ser diferente a la actual',
    passwordChangeError: 'Error al cambiar la contrasena',
    accountInfo: 'Informacion de la cuenta',
    role: 'Rol',
    memberSince: 'Miembro desde',
  },

  notifications: {
    title: 'Notificaciones',
    markAllRead: 'Marcar todas como leidas',
    noNotifications: 'No tienes notificaciones',
    new: 'Nueva',
  },

  petitions: {
    title: 'Peticiones',
    subtitle: 'Gestiona tus solicitudes y peticiones',
    newPetition: 'Nueva Peticion',
    editPetition: 'Editar Peticion',
    deletePetition: 'Eliminar Peticion',
    deleteConfirm: 'Estas seguro que deseas eliminar esta peticion?',
    withAIAssistant: 'Con Asistente IA',
    quickForm: 'Formulario Rapido',
    statuses: {
      requested: 'Solicitada',
      analyzing: 'En Analisis',
      feedback: 'Esperando Info',
      costing: 'Costeando',
      presented: 'Presentada',
      approved: 'Aprobada',
      rejected: 'Rechazada',
      converted: 'Convertida',
    },
    categories: {
      new_feature: 'Nueva Funcionalidad',
      improvement: 'Mejora',
      bug_report: 'Reporte de Error',
      change_request: 'Cambio',
      support: 'Soporte',
      other: 'Otro',
    },
  },

  aiChat: {
    title: 'Asistente IA',
    subtitle: 'Te ayudo a definir tu peticion',
    welcome: 'Bienvenido al Asistente IA',
    welcomeMessage: 'Cuentame que necesitas y te ayudare a crear una peticion clara y bien estructurada para el equipo de desarrollo.',
    suggestions: 'Puedes decirme cosas como:',
    suggestion1: 'Necesito agregar una funcionalidad nueva para...',
    suggestion2: 'Hay un problema con...',
    suggestion3: 'Me gustaria mejorar...',
    generateDraft: 'Generar Borrador',
    generatedByAI: 'Generado por IA',
    placeholder: 'Escribe tu mensaje...',
    sendHint: 'Presiona Enter para enviar, Shift+Enter para nueva linea',
    errorSending: 'Error al enviar el mensaje',
    errorGenerating: 'Error al generar el borrador',
    sessionLimit: 'Limite de mensajes alcanzado',
    dailyLimit: 'Limite diario de mensajes alcanzado',
    formPanel: {
      title: 'Formulario de Peticion',
      subtitle: 'Revisa y envia tu solicitud',
    },
  },

  backlog: {
    title: 'Backlog',
    subtitle: 'Todos los requerimientos de todos los proyectos',
    tabBacklog: 'Backlog',
    tabSprints: 'Sprints',
    board: 'Tablero',
    newSprint: 'Nuevo Sprint',
    editSprint: 'Editar Sprint',
    newSprintDescription: 'Crea un nuevo sprint para organizar el trabajo',
    editSprintDescription: 'Modifica los datos del sprint',
    sprintNamePlaceholder: 'Sprint 1',
    goal: 'Objetivo',
    goalPlaceholder: 'Objetivo del sprint...',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    selectSprint: 'Seleccionar sprint',
    noSprints: 'No hay sprints creados',
    noSprintSelected: 'No hay sprint seleccionado',
    selectSprintHint: 'Selecciona un sprint para ver su tablero',
    items: 'items',
    selected: 'seleccionados',
    assign: 'Asignar',
    assignToSprint: 'Asignar a Sprint',
    removeFromSprint: 'Quitar del Sprint',
    project: 'Proyecto',
    startSprint: 'Iniciar Sprint',
    completeSprint: 'Completar Sprint',
    cancelSprint: 'Cancelar Sprint',
    confirmStartTitle: 'Iniciar Sprint',
    confirmStartDescription: 'Al iniciar el sprint se marcara como activo. Solo puede haber un sprint activo a la vez.',
    confirmCompleteTitle: 'Completar Sprint',
    confirmCompleteDescription: 'Los requerimientos que no llegaron a produccion volveran al backlog sin sprint asignado.',
    confirmCancelTitle: 'Cancelar Sprint',
    confirmCancelDescription: 'Todos los requerimientos seran removidos del sprint y volveran al backlog.',
    daysRemaining: 'dias restantes',
    endsToday: 'Termina hoy',
    overdue: 'Vencido',
    velocity: 'Velocidad',
    averageVelocity: 'Velocidad promedio',
    filters: {
      project: 'Proyecto',
      type: 'Tipo',
      priority: 'Prioridad',
      sprint: 'Sprint',
      devStatus: 'Estado Dev',
      defStatus: 'Estado Def',
      noSprint: 'Sin Sprint',
    },
  },

  errors: {
    generic: 'Ha ocurrido un error',
    notFound: 'No encontrado',
    unauthorized: 'No autorizado',
    forbidden: 'Acceso denegado',
    serverError: 'Error del servidor',
    networkError: 'Error de conexion',
    validationError: 'Error de validacion',
    requiredField: 'Este campo es requerido',
    invalidEmail: 'Email invalido',
    invalidPhone: 'Telefono invalido',
    invalidUrl: 'URL invalida',
    minLength: 'Minimo {min} caracteres',
    maxLength: 'Maximo {max} caracteres',
    minValue: 'Valor minimo: {min}',
    maxValue: 'Valor maximo: {max}',
    invalidDate: 'Fecha invalida',
    futureDateRequired: 'La fecha debe ser futura',
  },

  confirmations: {
    delete: 'Estas seguro que deseas eliminar este elemento?',
    unsavedChanges: 'Tienes cambios sin guardar. Deseas salir de todos modos?',
    logout: 'Estas seguro que deseas cerrar sesion?',
  },

  implementations: {
    title: 'Implementaciones',
    subtitle: 'Gestiona las implementaciones',
    empty: 'No hay implementaciones',
    emptyDesc: 'Crea tu primera implementación para organizar el despliegue',
    errors: {
      fetchAll: 'Error al obtener implementaciones',
      fetchOne: 'Error al obtener la implementación',
      create: 'Error al crear la implementación',
      update: 'Error al actualizar la implementación',
    },
  },
  
  timelineEvents: {
    title: 'Historial y Eventos',
    addEvent: 'Añadir Evento',
    editEvent: 'Editar Evento',
    empty: 'No hay eventos en el historial',
    emptyDesc: 'Registra hitos, reuniones o actualizaciones importantes',
    types: {
      milestone: 'Hito',
      meeting: 'Reunión',
      release: 'Lanzamiento',
      note: 'Nota',
      update: 'Actualización',
      incident: 'Incidencia'
    },
    status: {
      planned: 'Planeado',
      completed: 'Completado',
      cancelled: 'Cancelado'
    }
  },
}
